module.exports = __webpack_public_path__ + "img/the_black_family_tree.636ef9be.jpg";